import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import Activity from '@components/EntityActivity/Activity'

import { activityKeys } from '@functions/activity'

import useActivities from '@hooks/useActivities'
import { generateUrls } from '@hooks/useActivity'

import defaultRequestOptions from '@sections/Client/packs/Campaign/defaultRequestOptions'

export const icon = faClockRotateLeft

export const configOptions = () => ({
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  key: {
    component: 'select',
    key: 'key',
    label: 'Key',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All Keys' },
      ...activityKeys.map(activityKey => ({ key: activityKey.key, label: activityKey.key })),
    ],
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 5, label: '5' },
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface ActivitiesProps {
  customOptions: {
    queryParams: {
      key?: string,
      limit?: number,
    },
    customization: {
      title?: string,
    },
  },
  editing: boolean,
}

const Activities = (props: ActivitiesProps) => {
  const {
    customOptions: {
      customization,
      queryParams,
    },
    editing,
  } = props

  const { title } = customization || {}

  const { campaignId } = useNumericParams()

  const { loading } = useActivities()

  const { activitiesIndexUrl } = generateUrls({ id: campaignId }, {
    prefixRoute: `campaigns/${campaignId}/edit`,
  })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      headerRight={(
        <Link
          href={activitiesIndexUrl}
          textProps={{ fontSize: 'small' }}
        >
          Manage
        </Link>
      )}
      loading={loading}
      title={title || 'Activity'}
    >
      {!loading && (
        <Activity
          boxProps={{ maxHeight: 450, marginTop: 0 }}
          filters={queryParams}
          disableLoading
          itemProps={{ boxProps: { padding: 'large' } }}
          requestOptions={defaultRequestOptions.activity}
          subjectId={campaignId}
          subjectType="Campaign"
        />
      )}
    </DashboardModule>
  )
}

export default Activities
